(function() {
    'use strict';

    angular
        .module('josdaviApp')
        .controller('NiveauDialogController', NiveauDialogController);

    NiveauDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$uibModalInstance', 'entity', 'Niveau'];

    function NiveauDialogController ($timeout, $scope, $stateParams, $uibModalInstance, entity, Niveau) {
        var vm = this;

        vm.niveau = entity;
        vm.clear = clear;
        vm.save = save;

        $timeout(function (){
            angular.element("input[type='text']:eq(0)").focus();
        });

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if (vm.niveau.id !== null) {
                Niveau.update(vm.niveau, onSaveSuccess, onSaveError);
            } else {
                Niveau.save(vm.niveau, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('josdaviApp:niveauUpdate', result);
            $uibModalInstance.close(result);
            vm.isSaving = false;
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
